import { createContext, useContext } from 'react'
import type { DictPath } from './translate'

export type TFunction = (
    key: DictPath,
    params?: Record<string, string | number>,
) => string

export const I18nContext = createContext<TFunction | null>(null)

/** t('nav.tracking') bzw. t('timer.started', { type: 'Arbeit' }). */
export function useT(): TFunction {
    const t = useContext(I18nContext)
    if (!t) throw new Error('useT kann nur innerhalb von I18nProvider genutzt werden')
    return t
}
